module.exports = __webpack_public_path__ + "static/media/BG_65.b652efaf.png";